import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="flex items-center justify-center w-full h-full min-h-[420px] bg-slate-950/80 rounded-2xl">
            <div className="text-center px-6">
              <p className="text-red-400 text-sm font-medium mb-2">3D 预览渲染出错</p>
              <p className="text-white/50 text-xs font-mono">{this.state.error?.message ?? '未知错误'}</p>
              <button
                onClick={() => this.setState({ hasError: false })}
                className="mt-4 px-3 py-1.5 bg-white/10 hover:bg-white/20 text-white/80 text-xs rounded transition-colors"
              >
                重试
              </button>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
